<template>
  <div>
    <klickart-analytics-header :breadcrumb="$t('emailsList.title')"></klickart-analytics-header>
    <div class="container no-padding">
      <div class="box box--purple no-padding">
        <header class="clearfix p-large p-mobile--small">
          <span class="fz--medium pt--xsmall pulled-left mobile-full">
            <i class="icon-kp-mail mr--small va--middle"></i>
            {{ $tc('emailsList.capturedEmails', numberOfEmails, { count: numberOfEmails}) }}
          </span>

          <div class="pulled-right">
            <button class="button button--purple mobile-full" @click="exportEmails">
              <i class="fa icon-kp-arrow-down"></i>{{ $t('emailsList.export.button') }}
            </button>
            <input-search></input-search>
          </div>
        </header>
        <list v-show="numberOfEmails > 0"></list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import KlickartAnalyticsHeader from './screens/Layout/components/KlickartAnalyticsHeader';
import List from './screens/Emails/components/List';
import InputSearch from './screens/Emails/components/Search';

export default {
  created() {
    this.resetEmailRequestParams();
    this.getCapturedEmails(this.$route.params.pageIdentifier);
  },
  components: {
    KlickartAnalyticsHeader,
    List,
    InputSearch,
  },
  computed: mapGetters({
    numberOfEmails: 'emails/numberOfEmails',
  }),
  methods: mapActions({
    resetEmailRequestParams: 'emails/resetEmailRequestParams',
    getCapturedEmails: 'emails/getCapturedEmails',
    exportEmails: 'emails/exportEmails',
  }),
};
</script>



// WEBPACK FOOTER //
// src/Emails.vue